import Short from './Short';
import BackIcon from '../../assets/back.svg';
import './results.css';

const frontendURL = process.env.REACT_APP_URL;

const CHIPS = ['AI-selected highlights', 'Auto-captioned', 'Face-tracked', 'Virality scored', 'Ready for TikTok'];

const ShortsList = ({ userId, request, onBack, onSelect, ShortsMakerField }) => {
  const requestId = request?._id;
  const requestUserEmail = request?.userEmail;
  const shorts = Array.isArray(request?.shorts) ? request.shorts : [];

  const onBackHandle = () => {
    window.location.href = frontendURL;
  };

  return (
    <div className="scr">
      <div className="scr-inner">
        <button className="scr-back" onClick={onBackHandle}>
          <img src={BackIcon} alt="" /> Back
        </button>

        <div className="scr-head">
          <h2>Your shorts are ready</h2>
          <p>
            We analyzed your video and turned the best moments into ready-to-post vertical shorts.
            Preview each clip and its virality score, then publish it straight to TikTok, YouTube, or Instagram.
          </p>
          <div className="scr-chips">
            {CHIPS.map((chip) => (
              <span className="scr-chip" key={chip}>{chip}</span>
            ))}
          </div>
          {shorts.length > 0 && (
            <div className="scr-count">
              {shorts.length} {shorts.length === 1 ? 'short' : 'shorts'} generated
            </div>
          )}
        </div>

        <div className="scr-grid">
          {shorts.map((item, index) => (
            <Short
              key={item.id || item._id || index}
              userId={userId}
              requestUserEmail={requestUserEmail}
              item={item}
              index={index}
              ShortsMakerField={ShortsMakerField}
              requestId={requestId}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShortsList;
